import { createFileRoute } from "@tanstack/react-router";

import { SyncTasksContent } from "@/features/admin/sync-tasks/sync-tasks-content";

export const Route = createFileRoute("/admin/sync-tasks")({
  staticData: {
    title: "同步任务管理",
  },
  ssr: false,
  component: RouteComponent,
});

function RouteComponent() {
  return <SyncTasksContent />;
}
